import { Component } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'ca-form-error-message',
    templateUrl: './form-error-message.component.html',
    styleUrls: ['./form-error-message.component.scss'],
    imports: [IconComponent]
})
export class FormErrorMessageComponent {}
